import { isAxiosError } from 'axios';

export const parseError = (error: unknown): string | null => {
  if (isAxiosError(error)) {
    if (error.response) {
      const { status, statusText } = error.response;
      return `${status} ${statusText}`;
    }
    return error.message;
  } else if (error instanceof Error) {
    return error.message;
  } else if (typeof error === 'string') {
    return error;
  }
  return null;
};
